import { render, staticRenderFns } from "./AttachmentLabel.vue?vue&type=template&id=c766a0c0&"
import script from "./AttachmentLabel.vue?vue&type=script&lang=js&"
export * from "./AttachmentLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports